/**
 * @name 正则|格式化数据
 */

export default {
  mobile: /^[1][3-9][0-9]{9}$/
}
